import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { getWaLink, WA_MESSAGES } from "@/lib/joffreys-whatsapp";

const NAV = [
  { href: "#hero", label: "الرئيسية" },
  { href: "#why", label: "لماذا جوفريز" },
  { href: "#packages", label: "الباقات" },
  { href: "#serve", label: "من نخدم" },
  { href: "#faq", label: "الأسئلة" },
  { href: "#contact", label: "تواصل" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#hero" className="flex items-baseline gap-2">
          <span className={`text-2xl font-black tracking-tight ${scrolled ? "text-primary" : "text-white"}`}>
            Joffrey&apos;s
          </span>
          <span className={`text-xs font-bold ${scrolled ? "text-primary/70" : "text-cream/80"}`}>
            للجملة | Wholesale
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className={`text-sm font-medium transition-colors ${
                scrolled ? "text-charcoal hover:text-primary" : "text-cream/90 hover:text-white"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={getWaLink(WA_MESSAGES.hero)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-primary hover:bg-primary-dark text-primary-foreground px-5 py-2.5 text-sm font-bold transition-all hover:scale-[1.03] shadow-purple"
          >
            <WhatsAppIcon className="h-4 w-4" />
            تواصل واتساب
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className={`lg:hidden p-2 rounded-md ${scrolled ? "text-charcoal" : "text-white"}`}
          aria-label="القائمة"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t shadow-lg">
          <nav className="flex flex-col px-6 py-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-medium text-charcoal border-b border-border last:border-0"
              >
                {n.label}
              </a>
            ))}
            <a
              href={getWaLink(WA_MESSAGES.hero)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-3 font-bold"
            >
              <WhatsAppIcon className="h-4 w-4" />
              تواصل واتساب
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
